import React, { useState } from "react";
import { Segment } from "semantic-ui-react";
import PostSurveyContactDetails from "./2contactDetails";
import PostSurveySelfReflection from "./1selfReflection";

interface Props {
  postQuestionsEnded: () => void;
  userSurveyId: number;
  onNavigatePrevious: () => void;
}

export default function PostSurvey({ postQuestionsEnded, userSurveyId, onNavigatePrevious }: Props) {
  const [currentPage, setCurrentPage] = useState<number>(0);

  return (
    <>
      <Segment className="survey-intro-content">
        {/*currentPage === 0 && (
          <PostSurveyQuestionaire
            userSurveyId={userSurveyId}
            onNavigateNext={() => setCurrentPage(currentPage + 1)}
            onNavigatePrevious={() => onNavigatePrevious()}
          />
        )*/}

        <div style={{ display: currentPage === 0 ? "block" : "none" }}>
          <PostSurveySelfReflection
            userSurveyId={userSurveyId}
            onNavigateNext={() => setCurrentPage(currentPage + 1)}
            onNavigatePrevious={() => onNavigatePrevious()}
          />
        </div>

        <div style={{ display: currentPage === 1 ? "block" : "none" }}>
          <PostSurveyContactDetails
            userSurveyId={userSurveyId}
            onNavigateNext={() => postQuestionsEnded()}
            onNavigatePrevious={() => setCurrentPage(currentPage - 1)}
          />
        </div>
      </Segment>
    </>
  );
}
